var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg61LightRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 430.9 361.2",
    style: {
      enableBackground: "new 0 0 430.9 361.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.1,5.5c-50.7,0-92.8,38.9-97,89.1l-0.4,5.1h-11c-34.9,0-63.2,28.3-63.2,63.2s28.3,63.2,63.2,63.2H287 c42.2,0,76.5-34.2,76.5-76.5S329.3,73.1,287,73.1c-4,0-8,0.3-11.9,0.9l-4.5,0.7l-1.5-4.3C255.3,31.8,218.7,5.5,177.1,5.5L177.1,5.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1,16.6c-44.9,0-82.3,34.5-86,79l-1.3,15.2H68.6c-28.8,0-52.1,23.3-52.1,52.1c0,28.8,23.3,52.1,52.1,52.1h218.3 c36.1,0,65.4-29.3,65.4-65.4S323,84.2,286.9,84.2c-3.5,0-6.9,0.3-10.2,0.8l-13.6,2.1l-4.6-13C246.4,39.9,214,16.6,177.1,16.6 L177.1,16.6z M177.1,0c44.8,0,82.9,28.6,97.1,68.6c4.2-0.7,8.5-1,12.8-1c45.3,0,82,36.7,82,82s-36.7,82-82,82H68.7 C30.8,231.6,0,200.8,0,162.9s30.8-68.7,68.7-68.7h5.9C79,41.4,123.2,0,177.1,0L177.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283,58.3c-38.9,0-71.2,29.9-74.4,68.5l-0.3,3.9h-8.4c-26.8,0-48.5,21.7-48.5,48.6c0,26.8,21.7,48.6,48.5,48.6 h167.5c32.4,0,58.7-26.3,58.7-58.8s-26.3-58.8-58.7-58.8c-3.1,0-6.2,0.2-9.2,0.7l-3.5,0.5l-1.2-3.3C343,78.5,315,58.3,283,58.3 L283,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.5,70.9c-32.6,0-59.6,24.9-62.3,56.9l-1.3,15.2h-19.8c-20,0-36.2,16.1-36.2,36s16.2,36,36.2,36h167.8 c25.7,0,46.4-20.7,46.4-46.2s-20.8-46.2-46.4-46.2c-2.5,0-4.9,0.2-7.3,0.6l-13.6,2.1l-4.6-13C333.7,87.7,310.3,70.9,283.5,70.9z  M283.5,54.3c34.4,0,63.7,21.9,74.6,52.5c3.3-0.5,6.5-0.8,9.8-0.8c34.8,0,63,28.1,63,62.8s-28.2,62.8-63,62.8H200.2 c-29.2,0-52.8-23.5-52.8-52.6s23.6-52.6,52.8-52.6h4.5C208.1,86,242.1,54.3,283.5,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.5,330.2c0,17.1-13.9,31-31,31s-31-13.9-31-31c0-4.7,1.1-9.2,3-13.3l17.4-44.2c5.9-15,15.4-15,21.3,0 l17.3,44C240.5,320.9,241.5,325.6,241.5,330.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg61LightRain);
export default __webpack_public_path__ + "static/media/61_light_rain.75d856d32fd597461e08da23d118812d.svg";
export { ForwardRef as ReactComponent };